import { render } from "./GenericDataTable2.vue?vue&type=template&id=ca26e954&scoped=true"
import script from "./GenericDataTable2.vue?vue&type=script&lang=js"
export * from "./GenericDataTable2.vue?vue&type=script&lang=js"

import "./GenericDataTable2.vue?vue&type=style&index=0&id=ca26e954&scoped=true&lang=css"
import "./GenericDataTable2.vue?vue&type=style&index=1&id=ca26e954&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca26e954"]])

export default __exports__